import { FilterBar, FilterDateRange, FilterSingleSelect, FilterTimeRange } from "components/commons";
import React, { useCallback, useMemo } from "react";
import lang from "translations";

const RefundClaimReportFilter = ({
  filterState,
  modifyFilter,
  clearFilter,
  onClear,
  onApply,
}) => {
  const statusOptions = useMemo(
    () => [
      { value: "REFUNDED", text: lang.completed },
      { value: "", text: lang.all },
    ],
    []
  );

  const applyFilterCb = useCallback(
    async (searchKey) => {
      await onApply(searchKey);
    },
    [onApply]
  );

  const clearFilterCb = useCallback(() => {
    const { filterState, requestState } = clearFilter();
    onClear(filterState, requestState);
  }, [clearFilter, onClear]);

  return (
    <FilterBar
      className="my-lg"
      filterState={filterState}
      placeholder={lang.searchByGuestNameEmailTagUid}
      onClear={clearFilterCb}
      onApply={applyFilterCb}
    >
      <FilterDateRange
        id="dateRange"
        label={lang.dateRange}
        maxDays={90}
        value={filterState.dateRange}
        onChange={(value) => modifyFilter("dateRange", { value })}
      />
      <FilterTimeRange
        id="timeRange"
        label={lang.timeRange}
        value={filterState.dateRange}
        onChange={(value) => modifyFilter("dateRange", { value })}
      />
      <FilterSingleSelect
        id="status"
        label={lang.status}
        summaryFallback={lang.all}
        options={statusOptions}
        value={filterState.status}
        onChange={(value) => modifyFilter("status", { value })}
      />
    </FilterBar>
  );
};

export default RefundClaimReportFilter;
